import LegalPage from '../shared/LegalPage';
import { business } from '../content';
import { useLanguage } from '../language/LanguageContext';
import { fillTemplate } from '../language/translations';

function PrivacySecurity() {
  const { t } = useLanguage();
  const values = {
    appName: business.appName,
    companyName: business.companyName
  };

  return (
    <LegalPage
      title={t.privacy.title}
      intro={fillTemplate(t.privacy.intro, values)}
    >
      {t.privacy.sections.map((section) => (
        <section key={section.title}>
          <h2>{section.title}</h2>
          <p>{fillTemplate(section.body, values)}</p>
        </section>
      ))}

      <section>
        <h2>{t.privacy.contactTitle}</h2>
        <p>
          {t.privacy.contactText}{' '}
          <a href={`mailto:${business.privacyEmail}`}>{business.privacyEmail}</a>.
        </p>
      </section>
    </LegalPage>
  );
}

export default PrivacySecurity;
